<template lang='pug'>
.order-container
    .address-detail
        AddressPanel(:recipient="recipients[0]" v-if="recipients.length>0" @click.native="$router.push({name:'addressList'})")
        router-link.add-new(v-else :to="{name:'newAddress'}")
            van-icon.plus(name="plus")
            span.add 添加收件人信息
    .detail-wrapper
        Gift(:info="product")
        .detail
            .name {{product.name}}
            .stock 当前余量：{{product.stock}}
        .amount-wrapper
            van-stepper(v-model="redeemAmount" :min="1" :max="product.stock" integer)
    .footer-confirm(:class="{'error':isValid.err}")
        .cost 
            .val(v-if="isValid.err" @click="errLink(isValid.jump)") {{isValid.err}}
            .val(v-else) {{cost}}
                span.iconfont &#xe651;
        .confirm(@click="placeOrder") 提交订单

</template>

<script>
import { getProduct, placeOrder, getRecipients, getPointStoreSetting } from '@/service/member'

import { setStorage } from '@/utils/localstorage.js'
import Gift from '../components/Gift'
import AddressPanel from '../components/AddressPanel'
import { mapState, mapActions } from 'vuex'
import { checkAccess } from '@/service'
import mixin from '@/views/mixin'

export default {
    mixins: [mixin],
    components: {
        Gift,
        AddressPanel
    },
    data() {
        return {
            product: {},
            redeemAmount: 1,
            recipients: [],
            settings: {},
            // formQ: '683188118182084608'
            // formQ: '689658323821150208' //test
        }
    },
    computed: {
        ...mapState(['memberInfo', 'userInfo', 'levelSettings']),
        isValid() {
            if ((this.settings.redeemProductAuth && this.memberInfo.membershipLevel) && this.settings.redeemProductAuth.level > this.memberInfo.membershipLevel.level) {
                return { err: `点击成为${this.settings.redeemProductAuth.levelName}兑换礼品`, jump: true }
            }
            if (this.redeemAmount < 1) {
                return { err: '请选择正确的商品数量' }
            }
            if (!this.memberInfo.points) {
                return { err: '积分不足，请减少商品数量' }
            }
            if (!this.recipients[0]) {
                return { err: '请选择一个收货地址' }
            }
            return this.memberInfo.points - this.cost >= 0 ? { err: null } : { err: '积分不足，请减少商品数量' }
        },
        cost() {
            if (this.product.pointsCost) {
                return this.redeemAmount * this.product.pointsCost
            } else {
                return 0
            }
        }
    },
    methods: {
        ...mapActions(['getMemberInfo']),
        errLink(isJump) {
            if (isJump) {
                this.showConfirm(1)
            }
        },
        async  placeOrder() {
            // const { redirect } = await checkAccess(this.formQ)
            // if (redirect) {
            //         window.location.href = `${redirect.split('?')[0]}?name=order&id=${this.$route.params.id}`
            //     return
            // }
            this.$confirm({
                title: '兑换礼品',
                message: `确定兑换${this.redeemAmount}个${this.product.name}吗？`,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(async () => {
                try {
                    await placeOrder({
                        redeemAmount: this.redeemAmount,
                        productId: this.product.id,
                        recipientId: this.recipients[0].id
                    })
                    this.$alert({
                        title: '订单提交成功',
                        confirmButtonText: '查看我的订单'
                    }).then(async () => {
                        await this.getMemberInfo()
                        this.$router.push({ name: 'exchangeRecord' })
                    })
                } catch (error) {
                    this.$message.fail(error.message)
                }
            })

        },
        async initData() {
            this.product = await getProduct(this.$route.params.id)
            this.recipients = (await getRecipients()).data
            this.settings = await getPointStoreSetting()
            setStorage('te_m_order_productId', this.$route.params.id)
        },
    },
    created() {
        this.initData()
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/mixin.less';
.order-container {
    .address-detail {
        border-bottom: 3px dashed @background-color;
        .add-new {
            padding: @spacing;
            font-size: 0.8rem;
            line-height: 2;
            display: flex;
            align-items: center;
            .plus {
                font-size: 1rem;
                margin-right: 0.4rem;
            }
            .add {
                text-decoration: underline;
            }
        }
    }
    .detail-wrapper {
        padding: @spacing;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .detail {
            display: flex;
            height: 3.6rem;
            flex-direction: column;
            justify-content: space-between;
            .name {
                font-size: 0.8rem;
                max-width: 6rem;
                @include ellipsis;
            }
            .stock {
                font-size: 0.6rem;
                color: @mFaintColor;
            }
        }
        .amount-wrapper {
            align-self: flex-end;
        }
    }

    .footer-confirm {
        position: fixed;
        bottom: 0;
        height: 2.5rem;
        width: 100%;
        left: 0;
        display: flex;
        .cost {
            display: flex;
            flex: 1;
            height: 100%;
            align-items: center;
            font-size: 1.4rem;
            color: @themeColor;
            background: @background-color;
            padding-left: @spacing;
            .val {
                line-height: 1;
            }
            .iconfont {
                font-size: 0.65rem;
                margin-left: 0.35rem;
            }
        }
        .confirm {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            font-size: 1rem;
            background: @themeColor;
            color: #fff;
            flex: 1;
        }
    }
    .error {
        .cost {
            font-size: 0.65rem;
            border-right: 1px solid @mBorderColor;
        }
        .confirm {
            background: @background-color;
            color: @text-color;
            pointer-events: none;
        }
    }
}
</style>